import React from 'react';
import { Modal } from 'react-bootstrap';
import EmeraldMarketplace from "../../../assets/icon/emerald-marketplace.png";
import EmeraldReserve from "../../../assets/icon/emerald-reserve.png";
import closeicon from '../../../assets/icon/not-included.png';
import RoundButton from '../../common/RoundButton';

function ComingSoonModal({ showModal, setShowModal, type = 'Marketplace' }) {

  const closeModal = () => {
    setShowModal(false)
  }

  return (
    <Modal className='partner-unverified-modal' show={showModal} onHide={closeModal}>
      <Modal.Header>
        <div class="close-button" onClick={closeModal}> <img src={closeicon} alt="" /></div>
      </Modal.Header>
      <Modal.Body>
        <div className='partner-unverified-inner'>
          <div className="partner-unverified-avatar">
            <div className="partner-unverified-avatar-wrapper">
              <img src={type === "Marketplace" ? EmeraldMarketplace : EmeraldReserve} alt="" />
            </div>
          </div>
          <h4>Coming Soon!</h4>
          <p>You have to be patient the Emerald {type} is coming soon.</p>
          <RoundButton
            type="button"
            label="Continue"
            className="gred-btn mt-40 mb-4 w-50 change-password-button font-weight-semibold verify-now-btn"
            onClick={closeModal}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ComingSoonModal;
